import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { USER_ROLES } from '@shared/index';
export enum UserRolesForRoute {
  ParkingManager = '1',
  ParkingOwner = '2',
  SuperAdmin = '3',
  GroupUser = '4',
  Driver = '0'
}
@Component({
  selector: 'app-redirect-url-after-payment',
  templateUrl: './redirect-url-after-payment.component.html'
})

export class RedirectUrlAfterPaymentComponent implements OnInit{
  type: string = '';
  id: string | null = null;
  routeRole: any;
  userRoles = USER_ROLES;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly encryptStorage: EncryptionStorageService
  ) { }


  ngOnInit() {
    const role = this.encryptStorage.getItem('roleName');
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.type = params.get('type');
      this.routeRole = params.get('role');
    });

    if (!role) {
      this.router.navigate(['/login']);
      return;
    }

    if (this.type === '2') {
      if (role === this.userRoles.DRIVER) {
        this.router.navigate(['driver/invoice-list'], {
          queryParams: { tab: 1 }
        });
      }
      else if (role === this.userRoles.GROUP_USER) {
        this.router.navigate(['group-operator/invoice-list'], { queryParams: { tab: 1 } });
      }
      else if (role === this.userRoles.SUPER_ADMIN) {
        this.router.navigate(['super-admin/invoice-list'], { queryParams: { tab: 1 } });
      }
      else if (role === this.userRoles.PARKING_MANAGER || role === this.userRoles.PARKING_OWNER) {
        this.router.navigate(['manager/invoice-list'], { queryParams: { tab: 1 } });
      }
      else {
        this.router.navigate(['/login']);
      }

    }
    else {
      if ((this.isRoleCheck && this.routeRole === UserRolesForRoute.Driver)) {
        const basePath = role === this.userRoles.SUPER_ADMIN ? '/super-admin' : '/manager';
        this.router.navigate([`${basePath}/driver-info`], {
          queryParams: { id: this.id, tab: 0, iTab: 0 }
        });
      }
      else if (this.isRoleCheck && this.routeRole === UserRolesForRoute.GroupUser) {
        const basePath = role === this.userRoles.SUPER_ADMIN ? '/super-admin' : '/manager';
        this.router.navigate([`${basePath}/group-operator-info`], {
          queryParams: { Id: this.id, tab: 0, iTab: 0 }
        });
      }
      else if (role === this.userRoles.DRIVER && this.routeRole === UserRolesForRoute.Driver) {
        this.router.navigate(['/driver/booking'], { queryParams: { tab: 0 } });
      }
      else if (role === this.userRoles.GROUP_USER && this.routeRole === UserRolesForRoute.GroupUser) {
        this.router.navigate(['/group-operator/booking-list'], { queryParams: { tab: 0 } });
      }
      else{
         this.router.navigate(['/login']);
      }

    }
  }

  get isRoleCheck(): boolean {
    const role = this.encryptStorage.getItem('roleName');
    return (role === this.userRoles.PARKING_OWNER || role === this.userRoles.PARKING_MANAGER || role === this.userRoles.SUPER_ADMIN)
  }
}
